<template>
    <div class="d-flex flex-column align-center">
        <product-banner>Add More Campaigns</product-banner>
        <product-card id="545">
            <template #title>1 Blog Link Outreach Wire Pack</template>
            <template #description>
                With B.L.O.W. Packs, you will get links from established blogs
                across the internet. Our outreach team works with over 10,000
                publishers and each B.L.O.W pack allows you to publish to 4
                blogs. As we do 100% of the work, and you just pick what you
                want us to link to, it's an easy way to improve your online
                presence and link portfolio.
            </template>
        </product-card>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';

import { ProductBanner, ProductCard } from '@/components/ProductCard';
@Component({
    components: {
        ProductBanner,
        ProductCard
    }
})
export default class BLOW extends Vue {
    mounted() {
        this.$emit(
            'appointment',
            'https://try.ampifire.com/meetings/jamieh2/outreach'
        );
    }
}
</script>
